/* eslint-disable */
const state = {
    contract: {
        corporationsId: '',
        guestNumber: '',
        paymentInterval: '',
        paymentMethod: ''
    },
    creditInformation: { 
        cardInformationId: '',
        lastFourDigits: ''
    },
    accountInformation:
    {
        accountInformationId: '',
        accountNumber: ''
    }

}

const getters = {
    getContract(state) {
        return state.contract
    },
    getCreditInformation(state) {
        return state.creditInformation
    },
    getAccountInformation(state) {
        return state.accountInformation
    }
}

const mutations = {
    setContract(state, contract) {
        state.contract = contract
    },
    setCreditInformation(state, creditInformation) {
        state.creditInformation = creditInformation
    },
    setAccountInformation(state, accountInformation) {
        state.accountInformation = accountInformation
    }
}

const actions = {
    async updateContract({ commit }, contract) {
        commit('setContract', contract)
    },
    async updateCreditInformation({ commit }, creditInformation) {
        commit('setCreditInformation', creditInformation)
    },
    async updateAccountInformation({ commit }, accountInformation) {
        commit('setAccountInformation', accountInformation)
    }
}

export default {
    namespaced: false,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/contract.js